import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import Urls from '../../_core/constants/urls';
import { featureFlagGuard } from '../../_core/guards/feature-flag.guard';
import { FeatureFlagKeys } from '../../_core/models/FeatureFlags';
import { DonateFormComponent } from './donate-form/donate-form.component';
import { ManageRecurringComponent } from './manage-recurring/manage-recurring.component';
import { PostPaymentComponent } from './post-payment/post-payment.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: DonateFormComponent,
      },
      {
        path: Urls.MANAGE_RECURRING,
        component: ManageRecurringComponent,
        canActivate: [featureFlagGuard],
        data: {
          featureFlagKey: FeatureFlagKeys.RecurringContribution,
        },
      },
    ],
  },
  {
    path: Urls.CONFIRM,
    component: PostPaymentComponent,
  },
  {
    path: Urls.CANCEL,
    component: PostPaymentComponent,
  },
  {
    path: ':token',
    children: [
      {
        path: '',
        component: DonateFormComponent,
      },
      {
        path: Urls.CANCEL,
        component: PostPaymentComponent,
      },
      {
        path: Urls.CONFIRM,
        component: PostPaymentComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DonateRoutingModule {}
